import type { AxiosResponse } from 'axios';

import apiClient from '../api/apiClient';
import type { ItemType, UserSettingsItem } from './user.service';

const itemBaseURL = '/api/items';

/** Item row returned by GET /api/items (matches backend select). */
export type OwnedItem = UserSettingsItem;

class ItemService {
    getByType(userId: number, type: ItemType): Promise<AxiosResponse<OwnedItem[]>> {
        return apiClient.get<OwnedItem[]>(itemBaseURL, {
            params: {
                userId,
                type,
            },
        });
    }
}

export default new ItemService();
